import { FC } from 'react';
import { Button } from '../form/Button';
import { Modal } from '../modal/Modal';
import { ModalProps } from '../modal/useModal';
import { Card } from '../sections/Card';

export interface UnsavedChangesModalProps {
  onCancelCallback: () => void;
  onConfirmCallback: () => void;
}

export const UnsavedChangesModal: FC<ModalProps & UnsavedChangesModalProps> = ({
  onCancelCallback,
  onConfirmCallback,
  ...props
}) => {
  const { close, ...rest } = props;

  const onClose = () => {
    onCancelCallback();
    close();
  };

  const onConfirm = () => {
    onConfirmCallback();
    close();
  };

  return (
    <Modal className="md:max-w-xl" close={onClose} {...rest}>
      <Card className="w-full p-8">
        <div className="flex flex-col gap-2">
          <Modal.Controls close={onClose} {...rest}>
            <h1 className="text-2xl font-semibold">Unsaved Changes</h1>
          </Modal.Controls>
          <div className="flex flex-col">
            <p>You have unsaved changes. Are you sure you want to leave?</p>
            <div className="flex justify-end gap-3 mt-5 items-center">
              <Button onClick={onClose}>Cancel</Button>
              <Button onClick={onConfirm}>Leave without saving</Button>
            </div>
          </div>
        </div>
      </Card>
    </Modal>
  );
};
